import React from "react";
import styles from "./Card.module.css";

type Props = {
    children: React.ReactNode;
};

export default function Card(props: Props) {
    return <div className={styles.container}>{props.children}</div>;
}
